{
  "Accessibility Menu": "የተደረሰ ምናሌ",
  "Reset settings": "ቅንብሮችን ዳግም አስጀምር",
  "Close": "ዝጋ",
  "Content Adjustments": "የይዘት ማስተካከያዎች",
  "Adjust Font Size": "የፊደል መጠን አስተካክል",
  "Highlight Title": "ርዕስን አበራ",
  "Highlight Links": "አገናኞችን አበራ",
  "Readable Font": "ተነባቢ ፊደል",
  "Color Adjustments": "የቀለም ማስተካከያዎች",
  "Dark Contrast": "ጨለማ መለያየት",
  "Light Contrast": "ብርሃን መለያየት",
  "High Contrast": "ከፍተኛ መለያየት",
  "High Saturation": "ከፍተኛ መጠን ያለው ቀለም",
  "Low Saturation": "ዝቅተኛ መጠን ያለው ቀለም",
  "Monochrome": "አንደኛ ቀለም",
  "Tools": "መሳሪያዎች",
  "Reading Guide": "የንባብ መመሪያ",
  "Stop Animations": "አንዲሶችን አቁም",
  "Big Cursor": "ትልቅ አዝራር",
  "Increase Font Size": "የፊደል መጠን አሳድግ",
  "Decrease Font Size": "የፊደል መጠን አሳንስ",
  "Letter Spacing": "የፊደል ክፍተት",
  "Line Height": "የመስመር ከፍታ",
  "Font Weight": "የፊደል ክብደት",
  "Dyslexia Font": "የዲስሌክሲያ ፊደል",
  "Language": "ቋንቋ",
  "Open Accessibility Menu": "የተደረሰ ምናሌን ክፈት",
  "Accessibility Profiles": "የተደረሰ ምናሌ መገለጫዎች",
  "Seizure Safe Profile": "የመቆለፊያ አደጋ አልባ መገለጫ",
  "Stops animations and reduces color saturation.": "እንቅስቃሴዎችን ይቆም እና የቀለም መጠን ያቀናል።",
  "Blind Profile": "ዓይነት አለመታየት መገለጫ",
  "Activates the screen reader for auditory navigation.": "ለድምፅ ንዑስ መምሪያ የስክሪን አነባቢን ያነሳል።",
  "Visually Impaired Profile": "የዓይነት ጉዳት ያላቸው መገለጫ",
  "Enhances contrast and readability for low vision.": "ለዝቅተኛ ማየት የሚጠቅመውን የተለያዩነትና ተነባቢነት ያሳድጋል።",
  "ADHD Friendly Profile": "ለADHD መልካም መገለጫ",
  "Reduces distractions for better focus.": "ለምርኮኞ ትኩረት መከላከያዎችን ያቀናል።",
  "Cognitive & Learning Profile": "የአእምሮ እና የመማር መገለጫ",
  "Helpful tools for reading and comprehension.": "ለንባብና ለመረዳት አገዛዝ የሚያደርጉ መሳሪያዎች።",
  "Motor Impaired Profile": "የእንቅስቃሴ ጉዳት ያላቸው መገለጫ",
  "Optimizes the site for keyboard-only navigation.": "ለቁልፍ ማስተካከያ ብቻ የሚሰራ እንዲሆን ድህረ ገጹን ያሻሽላል።",
  "Headings": "ርዕሶች",
  "Landmarks": "የተለየ ነጥቦች",
  "Links": "አገናኞች",
  "Focus element": "የትኩረት ንጥል",
  "Visit link": "አገናኝ ጎብኝ"
}